<!--
@Author: Tom Voorneveld <tom>
@Date:   2017-11-25T14:52:33+01:00
@Email:  tom@lorinthe.com
@Project: Lorinthe Template for other pages than the Landing page
@Last modified by:   tom
@Last modified time: 2019-06-12T17:03:46+02:00
@Copyright: (c) copyright Lorinthe BV, all rights reserved

The default page template for the majority of the pages:

 - Title block with jumbotron and optional jumbo background image
 - Optional left column with all optional:
     side title
     side image
     sise panel

Example:

  <c-page id="career"
      :title="$t('career.header.title')"
      :jbheader="$t('career.header.subtitle')"
      :jblead="$t('career.header.lead')"
      sidetitle="All our chapters"
      sideimage="img/career/team.jpg"
      jbimage="img/solutions/b2c.jpg"
      jbvariant="success"
      zoom-modal>
    <div slot="sidepanel">Hello in side panel</div>
  </c-page>

  sideimage = optional, without payload is full 12 columns
  jbimage = optional, uses side image if not given

-->

<template>
  <div>
    <section>
      <!-- only top margin on screens > xs -->
      <div
        id="qrespi-page"
        class="d-none d-sm-block mt-4"/>

      <b-container id="title" class="header text-primary pb-2" >
        <h1 v-html="title"/>
      </b-container>

      <!-- :bg-variant="jbvariant" -->
      <!-- Increase margin on wide screens  -->
      <div class="d-none d-sm-block mt-2"/>
      <div
        id="under-jumbo"
        :style="{ backgroundImage: `url('${jumboBackGrImage}')`, backgroundColor: underVariant }">
        <b-jumbotron
          id="page-jumbotron"
          :style="{ background: jumboBackgrGradient}"
          class="mt-2"
          text-variant="white"
          border-variant="dark" >
          <template slot="header">
            <div class="container" v-html="jbheader"/>
          </template>
          <template slot="lead" class="container">
            <div class="container" v-html="jblead"/>
          </template>
        </b-jumbotron>
      </div>

      <!-- show Horizontal Line if no sideimage AND on x-small screens -->
      <div
        v-if="!sideimage"
        class="mb-0 pb-0 d-block d-xl-none d-lg-none d-md-none d-sm-none">
        <hr>
      </div>

      <b-container>
        <b-row no-gutter>
          <b-col
            v-if="sidepanel || sideimage || sidetitle"
            id="left-page-column"
            class="d-none d-sm-block"
            md="2">

            <!-- We have a left column to show -->
            <div class="mb-2">&nbsp;</div>
            <h5 v-if="sidetitle" class="text-primary mb-2" v-html="sidetitle"/>

            <lzimg
              v-if="sideimage"
              id="sideimage"
              :src="sideimage"
              :zoom-modal="zoomModal"
              style="border: 1px solid #aaa;"
              class="mb-2"
              fluid
              width="600"
              height="450" />

            <slot name="sidepanel"/>

          </b-col>
          <!-- columns with cards flow a bit nicer when forcing md -->
          <b-col v-if="sidepanel || sideimage || sidetitle" id="payload" md="10">
            <slot/>
          </b-col>
          <b-col v-else id="payload">
            <slot/>
          </b-col>
        </b-row>
      </b-container>

    </section>
    <navbottom/>
  </div>
</template>

<script>
import Vue from 'vue'
import invokeScrollEvent from '@/components/_shared/invokeScrollEvent'

export default {
  props: {
    // top title
    title: { type: String, default: '' },
    // jumbotron, hidden on xs screens (e.g. mobiles)
    jbheader: { type: String, default: '' },
    jblead: { type: String, default: '' },
    jbvariant: { type: String, default: 'info' },
    jbimage: { type: String, default: '' },

    // left column show on desktop only and if side image and/or scroll list
    // sidepanel: { type: Boolean, default: false },
    sidetitle: { type: String, default: '' },
    // side image to show fullwidth on mobiles
    sideimage: { type: String, default: '' },
    // side image optional as thumbnail, clickable for full screen modal
    zoomModal: { type: Boolean, default: false }
  },
  data: function () {
    return {
      // parallaxFolder: 'img/_page/',
      jumboBackgrGradient: '',
      jumboBackGrImage: this.jbimage || this.sideimage,
      underVariant: Vue.prototype.$COLOR_TABLE[this.jbvariant]
    }
  },
  computed: {
    // check if we have a sidepanel slot
    sidepanel: function () {
      return !!this.$slots.sidepanel
    }
  },
  mounted: function () {
    // kick the lazy loading
    invokeScrollEvent('Mounted "_page"', 200)

    // apply the semi transparent gradient to the jumbotron
    const rgbFromStr = hexToRgbStr(this.underVariant, 0.8)
    const rgbToStr = hexToRgbStr(this.underVariant, 0.4)
    this.jumboBackgrGradient = `linear-gradient(to right, ${rgbFromStr} 20%, ${rgbToStr})`
  }
}

function hexToRgbStr (hex, t = 1) {
  // remove the leading '#'
  hex.replace('#', '')
  // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
  var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i
  hex = hex.replace(shorthandRegex, function (m, r, g, b) {
    return r + r + g + g + b + b
  })
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
  const r = parseInt(result[1], 16)
  const g = parseInt(result[2], 16)
  const b = parseInt(result[3], 16)
  return result ? `rgba(${r},${g},${b},${t})` : 'rgba(0,0,0,1)'
}

</script>

<style lang="scss" scoped>

  #payload {
    h1,h2 {
      margin-top: .4em !important;
    }
  }

  // @media (max-width:600px) {
  //   #sideimage {
  //     padding: 2px;
  //   }
  // }

  #side-index {
    padding: 0;
    list-style-type: none;
    margin-left: 10px;
    font-variant: small-caps;
    text-transform: lowercase;
    li {
      line-height: 1;
      margin-bottom: 8px;
      span {
        margin-left: -10px;
      }
    }
  }

  #sideimgmodal {
    .modal-lg {
      max-width: 1200px;
    }
  }
  #under-jumbo {
    /* Create the parallax scrolling effect */
    background-attachment: fixed;
    background-repeat: no-repeat;
    // Fill the background as best as possible on ALL devices...
    background-size: cover;
    background-position-x: 33%;
    // background-position-y: 46px;
  }
  #page-jumbotron{
    background: none;
    h1 {
      font-size: 2.2em;
    }
  }

</style>
